module.exports = __webpack_public_path__ + "media/product/f-3-1013f98d.png";